import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Seo title="Terms of Service" description="Terms of Service for Domaleo Enterprise." />
      <section className="relative overflow-hidden pt-32 pb-16 lg:pt-40 lg:pb-20">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
        </div>
        <div className="relative container-px mx-auto max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">Terms of Service</h1>
          <p className="mt-3 text-slate-200">The terms that govern your use of our website and services.</p>
        </div>
      </section>
      <section className="container-px mx-auto max-w-4xl py-16 lg:py-24">
        <Reveal className="space-y-8 text-muted-foreground leading-relaxed">
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Acceptance of Terms</h2>
            <p className="mt-3">By accessing this website and engaging our services, you agree to be bound by these terms and all applicable laws and regulations.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Services</h2>
            <p className="mt-3">Domaleo Enterprise provides import & export, IT solutions, agricultural solutions, logistics and general supply services. Specific terms for each engagement are confirmed in a written agreement.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Intellectual Property</h2>
            <p className="mt-3">All content on this website is the property of Domaleo Enterprise and may not be reproduced without permission.</p>
          </div>
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground">Contact</h2>
            <p className="mt-3">For questions about these terms, contact us at info@domaleo.com.</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
